import { Component, Input, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gdialog-app',
  template: `
    <mat-card class="example-card">
      <mat-card-header>
        <div
          mat-card-avatar
          class="example-header-image"
          [style.background-image]="image"
        ></div>
        <mat-card-title>{{ node.titulo }}</mat-card-title>
        <mat-card-subtitle>{{ node.subtitulo }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>
          {{ node.descripcion }}
        </p>
      </mat-card-content>
    </mat-card>
  `,
  styleUrls: ['./graph.component.css'],
})
export class GDialogComponent implements OnInit {
  modal_type: string = 'node';
  image: any;
  node: any;
  action: string = 'Ver más';
  action2: string = 'Ver más';
  constructor(
    public dialogRef: MatDialogRef<GDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitization: DomSanitizer
  ) {}
  ngOnInit(): void {
    console.log(this.data.node);
    this.node = this.data.node;
    this.image = this.sanitization.bypassSecurityTrustStyle(
      `url(${this.node.image})`
    );
    console.log(this.node.raw.labels[0]);
    if (this.node.raw.labels[0] == 'Account') {
      this.node.titulo = this.node.label;
      this.node.subtitulo = 'Cuenta';
      this.node.descripcion = `Cuenta de un cliente.`;
      this.action = 'Ver transferencias hacia esta cuenta';
      this.action2 = 'Ver cliente de esta cuenta';
      this.modal_type = 'account';
    } else if (this.node.raw.labels[0] == 'Customer') {
      this.node.titulo = this.node.label;
      this.node.subtitulo = 'Cliente';
      this.node.descripcion = `CI: ${this.node.value}.`;
      this.action = 'Bucar cuentas de este cliente';
      this.modal_type = 'customer';
    }
  }

  onAction() {
    if (this.modal_type == 'customer') {
      this.dialogRef.close({
        type: this.modal_type,
        customer: this.node.value,
        search: 'Account',
      });
    } else if (this.modal_type == 'account') {
      this.dialogRef.close({
        type: this.modal_type,
        account: this.node.titulo,
        search: 'Transfer',
      });
    }
  }

  onAction2() {
    if (this.modal_type == 'customer') {
    } else if (this.modal_type == 'account') {
      this.dialogRef.close({
        type: this.modal_type,
        account: this.node.titulo,
        search: 'Customer',
      });
    }
  }
}
